import e from "./ExtensionValue.vue.script.js";
//#region src/specification-extensions/ExtensionValue.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=ExtensionValue.vue.js.map